// The app shell's adapter. The chrome — app bar, kebab menu, the missing-params, DuckDB-query and
// welcome dialogs, the page container — is @rdrive/plugin-dashboard-shell's DashboardShell
// (IA_ABSORPTION_PLAN 6b-1); this component binds the app's half onto it — theme, the welcome
// dialog's flags and the data load's trigger, the DuckDB export, the filter FAB — and starts the
// dashboard's boot (useDashboard().start(), 6b-2b). <router-view> needs no `components` entry:
// vue-router registers it globally (createDashboard's app.use(router); routes in
// dashboard.config.js).
import { DashboardShell } from '@rdrive/plugin-dashboard-shell';
import { StatusFilterFab } from '@rdrive/plugin-status-filter';
import setup from './setup.js';

export default {
  name: 'app',
  components: { DashboardShell, StatusFilterFab },
  setup,
};
